module.exports = __webpack_public_path__ + "static/img/qrhz.843dc879.png";